import { Alert, AlertTitle, Box } from "@mui/material";
import { useIntl } from "react-intl";

export const UnauthorizedPage = () => {
  const { formatMessage: t } = useIntl();
  return (
    <Box>
      <Alert severity="error">
        <AlertTitle>
          <strong>{t({ id: "unauthorizedLabel" })}</strong>
        </AlertTitle>
        {t({ id: "unauthorizedMessage" })}
      </Alert>
    </Box>
  );
};
